/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { Link, json, useNavigate } from "react-router-dom";
import Form from "react-validation/build/form";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { confirmAlert } from "react-confirm-alert";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import AddPartyService from "../../../../services/party/addparty.service";
import { getTrans as t } from "../../../../Localization/translations";
import Helper from "../../../../Helper";
import ButtonLoading from "../../../../components/Loder/buttonLoading";
import GetCompanyInfoService from "../../../../services/company/getCompanyInfoService";
import EditPartyService from "../../../../services/party/editParty.service";
import AddPartyAddressService from "../../../../services/party/address/addAddress.service";
import EditAddressService from "../../../../services/party/address/editAddressServices";
import authHeader from "../../../../services/auth-header";
import { API } from "../../../../backend";
import ACHproviderService from "../../../../services/ACHproviders/ACHproviderServices";
import { EXEMPTION_STATUS_OPTIONS } from "../../exemptionStatus";

function PartyAdd({
  setPartyId,
  id,
  setAddressId,
  address,
  setTab = null,
  partyType,
}) {
  let navigate = useNavigate();
  const [showResults, setShowResults] = React.useState(false);
  const myRef = useRef(null);
  const [establishment_date, setEstablishment] = useState(null);
  const [party_type, setParty_type] = useState(["Customer"]);
  const [customer_type, setCustomer_type] = useState("Organization");
  const [customer_name, setCustomer_name] = useState("");
  const [sales_tax_code, setSales_tax_code] = useState("");
  const [TIN_number, setTIN_number] = useState("");
  const [website, setWebsite] = useState("");
  const [prefix, setPrefix] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [middle_name, setMiddle_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [ssn_tin_number, setSsn_tin_number] = useState("");
  const [id_number, setId_number] = useState("");
  const [id_issue_state, setId_issue_state] = useState("");
  const [date_of_birth, setDate_of_birth] = useState(null);
  const [disable, setDisable] = useState(false);
  const [party_series, setPartySeries] = useState("");
  // const [email, setEmail] = useState("")
  const [successful, setSuccessful] = useState(false);
  const checkBtn = useRef();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    clearErrors,
  } = useForm();
  const form = useRef();
  const [showhide, setShowHide] = useState("Organization");
  const [loading, setLoading] = useState(false);
  const [extrafiledparty, setExtraFiled] = useState([]);
  const [country_name, setCountry_name] = useState([]);
  const [filedparty, setExtraFiledparty] = useState([
    { attribute0: "" },
    { attribute1: "" },
    { attribute2: "" },
    { attribute3: "" },
    { attribute4: "" },
    { attribute5: "" },
    { attribute6: "" },
    { attribute7: "" },
    { attribute8: "" },
    { attribute9: "" },
    { attribute10: "" },
    { attribute11: "" },
    { attribute12: "" },
    { attribute13: "" },
    { attribute14: "" },
  ]);

  // Address Screen
  const [pre_bill_days, setpre_bill_days] = useState(null);
  const [consolidate_invoice, setConsolidate_invoice] = useState(null);
  const [generate_Invoice, setGenerate_Invoice] = useState(null);
  const [address_line_1, setAddress_line_1] = useState("");
  const [address_line_2, setAddress_line_2] = useState("");
  const [city, setCity] = useState("");
  const [stateaddress, setStateAddress] = useState("");
  const [stateaddressId, setStateAddressId] = useState("");
  const [state_name, setState] = useState([]);
  const [zip_code, setZip_code] = useState("");
  const [country, setCountry] = useState("");
  const [countryid, setCountryid] = useState("");
  const [bill_to, setBill_to] = useState("Yes");
  const [ship_to, setShip_to] = useState("Yes");
  const [install_to, setInstall_to] = useState("Yes");
  const [doingbusinessas, setDoingBusinessAs] = useState("");
  const [business_type, setBusinessType] = useState("");
  const [federalID, setFederalID] = useState("");
  const [sic, setSIC] = useState("");
  const [naics, setNAICS] = useState("");
  const [riskrating, setRiskRating] = useState("");
  const [creditscore, setCreditScore] = useState("");
  const [achPayments, setAchPayments] = useState(false);
  const [exemption_status, setExemptionStatus] = useState("");
  const isCustomer = party_type.includes('Customer');

  const handleCheckboxChange = (event) => {
    setAchPayments(event.target.checked);
  };

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm();

  const handleAddress = (id) => {
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      AddPartyAddressService.addPartyAddress(
        id,
        address_line_1,
        address_line_2,
        city,
        stateaddress,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setAddressId(response.data.addressId);
        } else {
        }
      });
    }
  };

  const getcountry = async () => {
    const res = await fetch(API + "helper/ajax/load-countries/");
    const getcon = await res.json();
    setCountry_name(await getcon);
  };

  const handlecountry = (event) => {
    const getcoutryId = event.target.value;
    setCountryid(getcoutryId);
    const countryName = country_name.filter(
      (val) => val.id === parseInt(getcoutryId)
    );
    const getcountryName = countryName[0]?.name || null;
    setCountry(getcountryName);
    reset({
      country_name: getcountryName,
    });
  };

  const handlestate = (event) => {
    const getstateId = event.target.value;
    setStateAddressId(getstateId);

    const stateName = state_name.filter(
      (val) => val.id === parseInt(getstateId)
    );
    const getstateName = stateName[0]?.name || null;
    setStateAddress(getstateName);
    // reset({
    //   state: getstateName
    // })
  };

  useEffect(() => {
    partyType(party_type);
  }, [party_type]);

  const getstate = async () => {
    const resst = await fetch(
      API + "helper/ajax/load-states/" + countryid + "/"
    );
    const getst = await resst.json();
    setState(await getst);
  };

  const [showACHPayments, setShowACHPayments] = useState(false);
  const Achprovider = () => {
    try {
      ACHproviderService.viewACHprovider().then((response) => {
        const achProviderCount = response.data.total;
        setShowACHPayments(achProviderCount === 1);
      });
    } catch (error) {
      console.error("Error fetching ACH providers:", error);
      setShowACHPayments(false);
    }
  };

  useEffect(() => {
    Achprovider();
  }, []);

  useEffect(() => {
    if (countryid !== null && countryid !== undefined) {
      getstate();
    }
  }, [countryid]);

  useEffect(() => {
    getcountry();
  }, []);

  const handleAddressupdate = () => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();
    if (checkBtn.current.context._errors.length === 0) {
      EditAddressService.editPartyAddressDetails(
        address,
        address_line_1,
        address_line_2,
        city,
        stateaddress,
        zip_code,
        country,
        bill_to,
        ship_to,
        install_to
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
        } else {
          setSuccessful(false);
        }
      });
    }
  };

  const executeScroll = () => myRef.current.scrollIntoView();

  const handleshowhide = (e) => {
    const getuser = e.target.value;
    setCustomer_type(e.target.value);
    setShowHide(getuser);
  };

  const handleConsolidateInvoice = (e) => {
    const getuser = e.target.value;
    setConsolidate_invoice(e.target.value);
    // setShowHide(getuser);
  };

  const handleGenerateInvoice = (e) => {
    const getuser = e.target.value;
    setGenerate_Invoice(e.target.value);
    // setShowHide(getuser);
  };

  useEffect(() => {
    if (id !== 0) {
      EditPartyService.getParty(id).then((response) => {
        setParty_type(response.data.party_type.split(", "));
        setCustomer_type(response.data.customer_type);
        setCustomer_name(response.data.customer_name);
        setSales_tax_code(response.data.sales_tax_code);
        setTIN_number(response.data.TIN_number);
        setWebsite(response.data.website);
        setPrefix(response.data.prefix);
        setFirst_name(response.data.first_name);
        setMiddle_name(response.data.middle_name);
        setLast_name(response.data.last_name);
        setSsn_tin_number(response.data.ssn_tin_number);
        setId_number(response.data.id_number);
        setId_issue_state(response.data.id_issue_state);
        setDate_of_birth(response.data.date_of_birth);
        setEstablishment(response.data.establishment_date);
        setShowHide(response.data.customer_type);
        setDoingBusinessAs(response.data.doingBusinessAs);
        setBusinessType(response.data.business_type);
        setFederalID(response.data.federalID);
        setSIC(response.data.SIC);
        setNAICS(response.data.NAICS);
        setRiskRating(response.data.riskrating);
        setCreditScore(response.data.creditscore);
        setAchPayments(response.data.ACHPayments);
        setExtraFiledparty([
          { attribute: response.data.attribute1 },
          { attribute: response.data.attribute2 },
          { attribute: response.data.attribute3 },
          { attribute: response.data.attribute4 },
          { attribute: response.data.attribute5 },
          { attribute: response.data.attribute6 },
          { attribute: response.data.attribute7 },
          { attribute: response.data.attribute8 },
          { attribute: response.data.attribute9 },
          { attribute: response.data.attribute10 },
          { attribute: response.data.attribute11 },
          { attribute: response.data.attribute12 },
          { attribute: response.data.attribute13 },
          { attribute: response.data.attribute14 },
          { attribute: response.data.attribute15 },
        ]);

        reset({
          party_type: response.data.party_type,
          customer_name: response.data.customer_name,
          customer_type: response.data.customer_type,
          first_name: response.data.first_name,
          last_name: response.data.last_name,
        });
      });
    }

    if (address !== null) {
      EditAddressService.getPartyAddressDetails(address).then((response) => {
        const countryVal = country_name.filter(
          (val) => val.name === response.data.country
        );
        const CountryId = countryVal[0]?.id || null;
        setCountryid(CountryId);
        const stateaddressVal = state_name.filter(
          (val) => val.name === response.data.state
        );
        const stateId = stateaddressVal[0]?.id || null;
        setStateAddressId(stateId);
        setAddress_line_1(response.data.address_line_1);
        setAddress_line_2(response.data.address_line_2);
        setCity(response.data.city);
        setStateAddress(response.data.state);
        setZip_code(response.data.zip_code);
        setCountry(response.data.country);
        setBill_to(response.data.bill_to);
        setShip_to(response.data.ship_to);
        setInstall_to(response.data.install_to);

        if (CountryId === null) {
          getLocation();
        }
        reset({
          address_line_1: response.data.address_line_1,
          city: response.data.city,
          zip_code: response.data.zip_code,
          country: response.data.country,
        });
      });
    }
    if (id === 0) {
      reset({
        customer_type: customer_type,
      });
    }
  }, [country_name, address, customer_type, id, state_name]);

  const handelDefault = () => {
    if (id !== 0) {
      handlepartyid();
    } else {
      form.current.validateAll();
      if (checkBtn.current.context._errors.length === 0) {
        AddPartyService.partyvalidate(customer_name).then((response) => {
          if (response.data.success) {
            handleRegister();
          } else {
            confirmAlert({
              title: "",
              message: `Party ${customer_name} is available.`,
              // message:
              //   "Party with the same name already exist. Are you sure you want to add party?.",
              buttons: [
                {
                  // label: "Yes",
                  label: "OK",
                  // onClick: () => handleRegister(),
                },
              ],
            });
          }
        });
      }
    }
  };

  const getExtrafiled = () => {
    GetCompanyInfoService.getExtraFiled().then((response) => {
      setExtraFiled(response.data.existparty);
    });
  };

  const party_number_method = async () => {
    await axios
      .get(API + `parties/party_number_method/`, { headers: authHeader() })
      .then((response) => {
        if (response.data.success === 1) {
          setPartySeries(response.data.details);
        } else {
          confirmAlert({
            title: "",
            message: "Go to settings and update Party Setting",
            buttons: [
              {
                label: "OK",
                onClick: () => navigate("/additionalsettings"),
              },
            ],
          });
        }
      });
  };

  useEffect(() => {
    getExtrafiled();
    party_number_method();
  }, []);

  const onChangeextrafileds = (e, index) => {
    const { name, value } = e.target;
    const rowsInput = [...filedparty];
    rowsInput[index][name] = value;
    setExtraFiledparty(rowsInput);
  };

  const handlepartyid = () => {
    setSuccessful(false);
    form.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    let generate_invoice = generate_Invoice;

    if (checkBtn.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }
      EditPartyService.editParty(
        id,
        party_type.join(", "),
        customer_type,
        customer_name,
        establishmentDate,
        TIN_number,
        sales_tax_code,
        website,
        prefix,
        first_name,
        middle_name,
        last_name,
        ssn_tin_number,
        id_number,
        id_issue_state,
        dateofbirth,
        filedparty,
        consolidate_invoice,
        pre_bill_days !== "" ? pre_bill_days : null,
        generate_invoice,
        doingbusinessas,
        business_type,
        federalID,
        sic,
        naics,
        riskrating,
        creditscore,
        achPayments,
        exemption_status
      ).then((response) => {
        if (response.data.success) {
          handleAddressupdate();
          toast.success(response.data.response, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          toast.error(response.data.error, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
    }
  };

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();
    let establishmentDate = null;
    let dateofbirth = null;
    let generate_invoice = generate_Invoice;
    if (checkBtn.current.context._errors.length === 0) {
      if (date_of_birth) {
        dateofbirth = Helper.DatePicker(date_of_birth);
      } else {
        setDate_of_birth(date_of_birth);
      }
      if (establishment_date) {
        establishmentDate = Helper.DatePicker(establishment_date);
      } else {
        setEstablishment(establishment_date);
      }

      AddPartyService.addParty(
        customer_type,
        party_type.join(", "),
        customer_name,
        establishmentDate,
        sales_tax_code,
        TIN_number,
        website,
        prefix,
        first_name,
        middle_name,
        last_name,
        ssn_tin_number,
        id_number,
        id_issue_state,
        dateofbirth,
        filedparty,
        consolidate_invoice,
        pre_bill_days !== "" ? pre_bill_days : null,
        generate_invoice,
        doingbusinessas,
        business_type,
        federalID,
        sic,
        naics,
        riskrating,
        creditscore,
        achPayments,
        exemption_status
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setDisable(true);
          setShowResults(true);
          handleAddress(response.data.partyId);
          toast.success(`${response.data.response}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setTimeout(() => {
            setLoading(false);
            if (setTab) {
              setPartyId(response.data.partyId);
              setTab(1);
            } else {
              navigate("/party");
            }
          }, 2000);
        } else {
          setLoading(false);
          setSuccessful(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 9000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });
    }
  };

  const handlePartyCheckbox = (e) => {
    const { value } = e.target;
    const updatedValues = [...party_type];

    if (e.target.checked) {
      updatedValues.push(value);
    } else {
      const index = updatedValues.indexOf(value);
      if (index > -1) {
        updatedValues.splice(index, 1);
      }
    }

    setParty_type(updatedValues);
  };

  const getLocation = () => {
    GetCompanyInfoService.getCompanyInfo().then((response) => {
      setCountryid(response.data.country);
    });
  };

  useEffect(() => {
    if (address === null) {
      getLocation();
    }
  }, [address]);

  useEffect(() => {
    if (countryid) {
      const countryName = country_name.filter(
        (val) => val.id === parseInt(countryid)
      );
      const getcountryName = countryName[0]?.name || null;
      setCountry(getcountryName);
      reset({
        country_name: getcountryName,
      });
    }
  }, [countryid, country_name]);

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleFields = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div>
      <ToastContainer />
      <div className="container-fluid ">
        <div className="header pb-0 mb-3">
          <h5>{t("Party Detail")}</h5>
        </div>
        <div className="card" role="document">
          <div className="card-body">
            <div className="row">
              <Form
                role="form text-left"
                onSubmit={handleSubmit(handelDefault)}
                ref={form}
                action="."
                method="POST"
                id="addPartyForm"
              >
                {
                  <>
                    <div className="row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Party Type")}{" "}
                          <Tooltip content={t("PartyType_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="form-group row">
                          <div className="col-12 col-md-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                value="Customer"
                                type="checkbox"
                                name="Customer"
                                // id="flexRadioDefault1"
                                checked={party_type.includes("Customer")}
                                {...register("party_type", {
                                  onChange: (e, value) => {
                                    handlePartyCheckbox(e);
                                  },
                                  required: true,
                                })}
                              />
                              <label
                                className="form-check-label"
                                // htmlFor="flexRadioDefault1"
                              >
                                Customer
                              </label>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                value="Vendor"
                                type="checkbox"
                                name="Vendor"
                                // id="flexRadioDefault2"
                                checked={party_type.includes("Vendor")}
                                {...register("party_type", {
                                  onChange: (e, value) => {
                                    handlePartyCheckbox(e);
                                  },
                                  required: true,
                                })}
                              />
                              <label
                                className="form-check-label"
                                // htmlFor="flexRadioDefault2"
                              >
                                Vendor
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="invalid-feedback">
                          {errors.party_type?.type === "required" &&
                            "Party Type  is required"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label className="col-form-label required">
                        {t("Entity Type")}{" "}
                        <Tooltip content={t("EntityType_Tooltip")}>
                          <i className="fa fa-light fa-circle-info"></i>
                        </Tooltip>
                      </label>
                      <div className="form-group row">
                        <div className="col-12 col-md-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              value="Person"
                              type="radio"
                              name="customer_type"
                              checked={customer_type === "Person"}
                              id="id_customer_type"
                              {...register("customer_type", {
                                onChange: (e) => {
                                  handleshowhide(e);
                                },
                                required: true,
                              })}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault1"
                            >
                              Person
                            </label>
                          </div>
                        </div>
                        <div className="col-12 col-md-6">
                          <div className="form-check">
                            <input
                              className="form-check-input"
                              value="Organization"
                              checked={customer_type === "Organization"}
                              type="radio"
                              name="customer_type"
                              id="id_customer_type"
                              {...register("customer_type", {
                                onChange: (e) => {
                                  handleshowhide(e);
                                },
                                required: true,
                              })}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="flexRadioDefault1"
                            >
                              Organization
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="invalid-feedback">
                        {errors.customer_type?.type === "required" &&
                          "Entity Type  is required"}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-3">
                        <label className="col-form-label required">
                          {t("Party Name")}{" "}
                          <Tooltip content={t("PartyName_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Party Name")}
                          className="form-control"
                          type="text"
                          value={customer_name}
                          name="customer_name"
                          maxLength="200"
                          id="id_customer_name"
                          {...register("customer_name", {
                            onChange: (e) => {
                              setCustomer_name(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.customer_name?.type === "required" &&
                            "Party Name  is required"}
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Address Line 1")}{" "}
                          <Tooltip content={t("Address_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 1")}
                          className="form-control"
                          type="text"
                          name="address_line_1"
                          maxLength="200"
                          id="id_address_line_1"
                          value={address_line_1}
                          {...register("address_line_1", {
                            onChange: (e) => {
                              setAddress_line_1(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.address_line_1?.type === "required" &&
                            "Address is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Address Line 2")}{" "}
                          <Tooltip content={t("Address2_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Address Line 2")}
                          className="form-control"
                          type="text"
                          onChange={(e) => setAddress_line_2(e.target.value)}
                          name="address_line_2"
                          maxLength="200"
                          id="id_address_line_2"
                          value={address_line_2}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Country")}{" "}
                          <Tooltip content={t("Country_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          type="text"
                          className="form-control"
                          value={countryid}
                          name="country"
                          {...register("country", {
                            onChange: (e) => {
                              handlecountry(e);
                            },
                            required: true,
                          })}
                        >
                          <option value="">---{t("Select Country")}---</option>
                          {country_name.map((country, i) => (
                            <option key={i} value={country.id}>
                              {country.name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.country?.type === "required" &&
                            "Country is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("State")}{" "}
                          <Tooltip content={t("State_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <select
                          value={stateaddressId}
                          className="form-control"
                          name="state"
                          {...register("state", {
                            onChange: (e) => {
                              handlestate(e);
                            },
                            required: true,
                          })}
                        >
                          <option value="">---{t("Select State")}---</option>
                          {state_name.map((resst, i) => (
                            <option key={i} value={resst.id}>
                              {resst.name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.state?.type === "required" &&
                            "State is required"}
                        </div>
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("City")}{" "}
                          <Tooltip content={t("City_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("City")}
                          className="form-control"
                          type="text"
                          name="city"
                          maxLength="100"
                          id="id_city"
                          value={city}
                          {...register("city", {
                            onChange: (e) => {
                              setCity(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.city?.type === "required" &&
                            "City is required"}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="col-form-label required">
                          {t("Zip Code")}{" "}
                          <Tooltip content={t("ZipCode_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Zip Code")}
                          className="form-control"
                          type="text"
                          name="zip_code"
                          maxLength="30"
                          id="id_zip_code"
                          value={zip_code}
                          {...register("zip_code", {
                            onChange: (e) => {
                              setZip_code(e.target.value);
                            },
                            required: true,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.zip_code?.type === "required" &&
                            "Zip Code is required"}
                        </div>
                      </div>
                      {
                        isCustomer && (
                            <div className="col-md-3">
                        <label className="col-form-label">
                          {t("Pre bill days")}{" "}
                          <Tooltip content={t("Pre_billdays_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Pre bill days")}
                          className="form-control no-spinner"
                          type="number"
                          name="pre_bill_days"
                          maxLength="200"
                          id="id_pre_bill_days"
                          value={pre_bill_days}
                          {...register("pre_bill_days", {
                            onChange: (e) => {
                              const value = e.target.value;

                              if (value < 0) {
                                setError("pre_bill_days", {
                                  type: "validate",
                                  message: "Value cannot be less than 0",
                                });
                              } else {
                                clearErrors("pre_bill_days");
                              }

                              setpre_bill_days(value);
                            },
                            required: false,
                            // validate: (value) => value >= 1 || "Value cannot be less than 0"
                          })}
                        />
                        <div className="invalid-feedback">
                          {/* {errors.pre_bill_days?.type === 'required' && "Pre bill days is required"} */}
                          {errors.pre_bill_days?.message}
                        </div>
                      </div>
                        )
                      }
                      
                      <div className="col-md-3">
                        <label className="col-form-label ">
                          {t("Doing Business As")}{" "}
                          <Tooltip content={t("DoingBusinessAs_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Doing Business As")}
                          className="form-control"
                          type="text"
                          name="DoingBusinessAs"
                          // maxLength="30"
                          id="id_zip_code"
                          value={doingbusinessas}
                          {...register("DoingBusinessAs", {
                            onChange: (e) => {
                              setDoingBusinessAs(e.target.value);
                            },
                            required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.DoingBusinessAs?.type === "required" &&
                            "Doing Business As is required"}
                        </div>
                      </div>

                     { showhide === "Organization" &&(
                      <>
                      <div className="col-md-3">
                        <label className="col-form-label ">
                          {t("Business Type")}{" "}
                          <Tooltip content={t("Business_Type_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Business Type")}
                          className="form-control"
                          type="text"
                          name="Business_Type"
                          // maxLength="30"
                          id="id_Business_Type"
                          value={business_type}
                          {...register("Business_Type", {
                            onChange: (e) => {
                              setBusinessType(e.target.value);
                            },
                            required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.Business_Type?.type === "required" &&
                            "Business Type  is required"}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label className="col-form-label ">
                          {t("Federal ID")}{" "}
                          <Tooltip content={t("FederalID_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Federal ID")}
                          className="form-control"
                          type="text"
                          name="FederalID"
                          // maxLength="30"
                          id="id_FederalID"
                          value={federalID}
                          {...register("FederalID", {
                            onChange: (e) => {
                              setFederalID(e.target.value);
                            },
                            required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.FederalID?.type === "required" &&
                            "Federal ID  is required"}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label className="col-form-label ">
                          {t("SIC")}{" "}
                          <Tooltip content={t("SIC_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("SIC")}
                          className="form-control"
                          type="text"
                          name="SIC"
                          // maxLength="30"
                          id="id_SIC"
                          value={sic}
                          {...register("SIC", {
                            onChange: (e) => {
                              setSIC(e.target.value);
                            },
                            required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.SIC?.type === "required" &&
                            "SIC  is required"}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label className="col-form-label ">
                          {t("NAICS")}{" "}
                          <Tooltip content={t("NAICS_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("NAICS")}
                          className="form-control"
                          type="text"
                          name="NAICS"
                          // maxLength="30"
                          id="id_SIC"
                          value={naics}
                          {...register("NAICS", {
                            onChange: (e) => {
                              setNAICS(e.target.value);
                            },
                            required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.NAICS?.type === "required" &&
                            "NAICS  is required"}
                        </div>
                      </div>
                      </>
                     )}
                     {showhide === 'Person' &&(<>
                      <div className="col-md-3">
                        <label className="col-form-label ">
                          {t("Risk Rating")}{" "}
                          <Tooltip content={t("RiskRating_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Risk Rating")}
                          className="form-control"
                          type="text"
                          name="RiskRating"
                          // maxLength="30"
                          id="id_RiskRating"
                          value={riskrating}
                          {...register("RiskRating", {
                            onChange: (e) => {
                              setRiskRating(e.target.value);
                            },
                            required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.RiskRating?.type === "required" &&
                            "RiskRating  is required"}
                        </div>
                      </div>
                      <div className="col-md-3">
                        <label className="col-form-label ">
                          {t("Credit Score")}{" "}
                          <Tooltip content={t("CreditScore_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <input
                          placeholder={t("Credit Score")}
                          className="form-control"
                          type="text"
                          name="CreditScore"
                          // maxLength="30"
                          id="id_CreditScore"
                          value={creditscore}
                          {...register("CreditScore", {
                            onChange: (e) => {
                              setCreditScore(e.target.value);
                            },
                            required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.CreditScore?.type === "required" &&
                            "CreditScore  is required"}
                        </div>
                      </div>
                      </>)}
                    </div>
                    <div className="row">
                      {/* <div className="col-md-6"> */}
                      {/* <label className="col-form-label">
                          {t("Consolidate Invoice")}{" "}
                          <Tooltip content={t("Consolidate invoice_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="form-group row">
                          <div className="col-12 col-md-6">
                            <div
                              className="form-check"
                            >
                              <input
                                className="form-check-input"
                                value="Yes"
                                type="radio"
                                name="consolidate_invoice"
                                checked={consolidate_invoice === "Yes"}
                                id="id_consolidate_invoice"
                                {...register("consolidate_invoice", {
                                  onChange: (e) => {
                                    handleConsolidateInvoice(e);
                                  },
                                  required: false,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                Yes
                              </label>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                value="No"
                                checked={consolidate_invoice === "No"}
                                type="radio"
                                name="consolidate_invoice"
                                id="id_consolidate_invoice"
                                {...register("consolidate_invoice", {
                                  onChange: (e) => {
                                    handleConsolidateInvoice(e);
                                  },
                                  required: false,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div> */}

                      {/* <div className="invalid-feedback">
                        {errors.consolidate_invoice?.type === "required" &&
                          "Consolidate Invoice is required"}
                      </div> */}
                      {/* </div> */}
                      {isCustomer && (
<div className="col-md-6">
                              <label className="col-form-label">Exemption Status</label>
                              <select
                                className="form-control form-select"
                                name="exemption_status"
                                id="id_exemption_status"
                                value={exemption_status || ""}
                                onChange={(e) => setExemptionStatus(e.target.value)}
                              >
                                <option value="">None (taxable)</option>
                                {EXEMPTION_STATUS_OPTIONS.map((o) => (
                                  <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                              </select>
                            </div>
                      )}
                      {
                        isCustomer && (

                      <div className="col-md-6">
                        <label className="col-form-label">
                          {t("Generate Invoice")}{" "}
                          <Tooltip content={t("Generate_invoice_Tooltip")}>
                            <i className="fa fa-light fa-circle-info"></i>
                          </Tooltip>
                        </label>
                        <div className="form-group row">
                          <div className="col-12 col-md-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                value="Yes"
                                type="radio"
                                name="generate_invoice"
                                checked={generate_Invoice === "Yes"}
                                id="id_generate_invoice"
                                {...register("generate_invoice", {
                                  onChange: (e) => {
                                    handleGenerateInvoice(e);
                                  },
                                  required: false,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                Yes
                              </label>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                value="No"
                                checked={generate_Invoice === "No"}
                                type="radio"
                                name="generate_invoice"
                                id="id_generate_invoice"
                                {...register("generate_invoice", {
                                  onChange: (e) => {
                                    handleGenerateInvoice(e);
                                  },
                                  required: false,
                                })}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="flexRadioDefault1"
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                        )
                      }
                      {isCustomer && showACHPayments === true && (
                        <div className="col-md-6">
                          <div
                            className="form-check col-md-6"
                            style={{
                              width: "100%",
                              paddingLeft: "2.73em",
                              paddingTop: "2.3em",
                            }}
                          >
                            <input
                              type="checkbox"
                              id="achPayments"
                              checked={achPayments}
                              onChange={handleCheckboxChange}
                              className="form-check-input"
                            />
                            <label
                              htmlFor="achPayments"
                              className="form-check-label tc  font-weight-bold"
                            >
                              {t("ACH Payments")}{" "}
                              <Tooltip content={t("Ach_Payments_Tooltip")}>
                                <i className="fa fa-light fa-circle-info"></i>
                              </Tooltip>
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                    {/* {generate_Invoice === "Yes" &&
                      <div className="col-md-3">
                        <label className="col-form-label">{t('Email')} <Tooltip content={t("Email_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
                        <input
                          placeholder={t('Email')}
                          className="form-control no-spinner"
                          type="text"
                          name="email"
                          id="email"
                          value={email}
                          {...register("email", {
                            onChange: (e) => {
                              const value = e.target.value;
                              setEmail(value)
                            }, required: false,
                          })}
                        />
                        <div className="invalid-feedback">
                          {errors.email?.message}
                        </div>
                      </div>
                    } */}
                    <h5
                      className="tc mt-4 cursor-pointer"
                      onClick={toggleFields}
                    >
                      {t("Additional Information")}{" "}
                      {isExpanded === true ? <FaAngleUp /> : <FaAngleDown />}
                    </h5>
                    {isExpanded === true && (
                      <>
                        {showhide === "Organization" && (
                          <>
                            <div className="form-group row">
                              <div className="col-sm-3">
                                <label className="col-form-label">
                                  {t("Establishment Date")}{" "}
                                  <Tooltip
                                    content={t("EstablishmentDate_Tooltip")}
                                  >
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <DatePicker
                                  className="form-control datepick"
                                  selected={
                                    establishment_date
                                      ? new Date(establishment_date)
                                      : ""
                                  }
                                  onChange={(e) => setEstablishment(e)}
                                  placeholderText={"mm/dd/yyyy"}
                                  showYearDropdown // year show and scrolldown alos
                                  scrollableMonthYearDropdown
                                  showMonthDropdown
                                  maxDate={new Date()}
                                  dropdownMode="select"
                                />
                              </div>
                              <div className="col-sm-3">
                                <label className="col-form-label">
                                  {t("Tax Number")}{" "}
                                  <Tooltip content={t("TaxNumber_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("Tax Number")}
                                  className="form-control"
                                  type="text"
                                  value={TIN_number}
                                  onChange={(e) =>
                                    setTIN_number(e.target.value)
                                  }
                                  name="TIN_number"
                                  maxLength="100"
                                  id="id_TIN_number"
                                />
                              </div>
                            </div>
                            <div className="form-group row">
                              <div className="col-sm-3">
                                <label className="col-form-label">
                                  {t("Sales Tax Code")}{" "}
                                  <Tooltip content={t("SalesTaxCode_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("Sales Tax Code")}
                                  className="form-control"
                                  type="text"
                                  value={sales_tax_code}
                                  onChange={(e) =>
                                    setSales_tax_code(e.target.value)
                                  }
                                  name="sales_tax_code"
                                  maxLength="100"
                                  id="id_sales_tax_code"
                                />
                              </div>
                              <div className="col-sm-3">
                                <label className="col-form-label">
                                  {t("Website")}{" "}
                                  <Tooltip content={t("Website_Tooltip")}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  placeholder={t("Website URL")}
                                  className="form-control"
                                  type="text"
                                  value={website}
                                  onChange={(e) => setWebsite(e.target.value)}
                                  name="website"
                                  maxLength="100"
                                  id="id_website"
                                />
                              </div>
                            </div>
                          </>
                        )}
                        {showhide === "Person" && (
                          <div className="form-group row">
                            {/* <div className="col-sm-3">
                                  <label className="col-form-label">
                                    {t("Prefix")}{" "}
                                    <Tooltip content={t("Prefix_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <select
                                    className="form-control form-select"
                                    name="prefix"
                                    onChange={(e) => setPrefix(e.target.value)}
                                    id="id_prefix"
                                  >
                                    <option value="" selected="">
                                      {t("Select Prefix")}
                                    </option>
                                    <option value="Mr">{t("Mr")}</option>
                                    <option value="Mrs">{t("Mrs")}</option>
                                    <option value="Ms">{t("Ms")}</option>
                                  </select>
                                </div>
                                <div className="col-sm-3">
                                  <label className="col-form-label required">
                                    {t("First Name")}{" "}
                                    <Tooltip content={t("FirstName_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("First Name")}
                                    className="form-control"
                                    type="text"
                                    value={first_name}
                                    name="first_name"
                                    maxLength="100"
                                    id="id_first_name"
                                    {...register("first_name", { onChange: (e) => setFirst_name(e.target.value), required: showhide === "Person" ? false : false })}
                                  />
                                  <div className="invalid-feedback">
                                    {errors.first_name?.type === 'required' && "First Name is required"}
                                  </div>
                                </div>
                                <div className="col-sm-3">
                                  <label className="col-form-label">
                                    {t("Middle Name")}{" "}
                                    <Tooltip content={t("MiddleName_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("Middle Name")}
                                    className="form-control"
                                    type="text"
                                    value={middle_name}
                                    onChange={(e) => setMiddle_name(e.target.value)}
                                    name="middle_name"
                                    maxLength="100"
                                    id="id_middle_name"
                                  />
                                </div>
                                <div className="col-sm-3">
                                  <label className="col-form-label required">
                                    {t("Last Name")}{" "}
                                    <Tooltip content={t("LastName_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("Last Name")}
                                    className=" form-control"
                                    type="text"
                                    value={last_name}
                                    onChange={(e) => setLast_name(e.target.value)}
                                    name="last_name"
                                    maxLength="100"
                                    id="id_last_name"
                                    {...register("last_name", { onChange: (e) => setLast_name(e.target.value), required: showhide === 'Person' ? false : false })}
                                  />
                                  <div className="invalid-feedback">
                                    {errors.last_name?.type === 'required' && "Last Name is required"}
                                  </div>
                                </div>

                                <div className="col-sm-3">
                                  <label className="col-form-label">
                                    {t("Tax Number")}{" "}
                                    <Tooltip content={t("TaxNumber_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    placeholder={t("Tax Number")}
                                    className="form-control"
                                    type="text"
                                    value={TIN_number}
                                    onChange={(e) => setTIN_number(e.target.value)}
                                    name="TIN_number"
                                    maxLength="100"
                                    id="id_TIN_number"
                                  />
                                </div> */}
                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("SSN / TIN Number")}{" "}
                                <Tooltip content={t("SSN/TINNumber_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("SSN / TIN Number")}
                                className="form-control"
                                type="text"
                                value={ssn_tin_number}
                                onChange={(e) =>
                                  setSsn_tin_number(e.target.value)
                                }
                                name="ssn_tin_number"
                                maxLength="100"
                                id="id_ssn_tin_number"
                              />
                            </div>
                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("ID Number")}{" "}
                                <Tooltip content={t("IDNumber_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("ID Number")}
                                className="form-control"
                                type="text"
                                value={id_number}
                                onChange={(e) => setId_number(e.target.value)}
                                name="id_number"
                                maxLength="100"
                                id="id_id_number"
                              />
                            </div>
                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("ID Issue State")}{" "}
                                <Tooltip content={t("IdIssueState_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <input
                                placeholder={t("ID Issue State")}
                                className="form-control"
                                type="text"
                                value={id_issue_state}
                                onChange={(e) =>
                                  setId_issue_state(e.target.value)
                                }
                                name="id_issue_state"
                                maxLength="30"
                                id="id_id_issue_state"
                              />
                            </div>
                            <div className="col-sm-3">
                              <label className="col-form-label">
                                {t("Date of Birth")}{" "}
                                <Tooltip content={t("DateofBirth_Tooltip")}>
                                  <i className="fa fa-light fa-circle-info"></i>
                                </Tooltip>
                              </label>
                              <DatePicker
                                className="form-control datepick"
                                selected={date_of_birth}
                                onChange={(e) => setDate_of_birth(e)}
                                placeholderText={"mm/dd/yyyy"}
                                scrollableYearDropdown
                                showMonthDropdown
                                showYearDropdown
                                scrollableMonthYearDropdown
                                maxDate={new Date()}
                                dropdownMode="select"
                              />
                            </div>
                          </div>
                        )}
                        <div className="form-group row">
                          {extrafiledparty.map((key, index) => (
                            <div
                              className={
                                key.enable === "True" ? "col-sm-3" : null
                              }
                            >
                              <>
                                <label
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  className="col-form-label"
                                >
                                  {" "}
                                  {key.label}{" "}
                                  <Tooltip content={key.label}>
                                    <i className="fa fa-light fa-circle-info"></i>
                                  </Tooltip>
                                </label>
                                <input
                                  className="form-control mb-1"
                                  name={"attribute" + index}
                                  type={key.datatype}
                                  style={{
                                    display:
                                      key.enable === "True" ? true : "none",
                                  }}
                                  placeholder={key.label}
                                  onChange={(e) =>
                                    onChangeextrafileds(e, index)
                                  }
                                />
                              </>
                            </div>
                          ))}
                        </div>
                      </>
                    )}

                    <div className="text-left  py-4 ">
                      <Link to={"/party"}>
                        <button type="button" className="btn btn-secondary ">
                          {t("Cancel")}
                        </button>
                        &nbsp;&nbsp;
                      </Link>
                      <button
                        type="submit"
                        className="border-0 btn btn-primary btn-gradient-primary btn-md"
                        disabled={disable}
                        onClick={executeScroll}
                      >
                        {loading === false ? (
                          // t("Save & Continue")
                          t("Save")
                        ) : (
                          <ButtonLoading />
                        )}
                      </button>
                      &nbsp;&nbsp;
                    </div>
                  </>
                }
                <CheckButton style={{ display: "none" }} ref={checkBtn} />
              </Form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartyAdd;
